import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { trackErrorInTrackJs } from '../../adapters/utils/utils.adapter';
import * as fromErrorHandlerActions from '../actions/error-handler.actions';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerEffects {
  handleError$ = createEffect(
    () =>
      this.ErrorHandlerActions$.pipe(
        ofType(fromErrorHandlerActions.HandleError),
        map(({ errorCode, error }) => {
          trackErrorInTrackJs(errorCode, error);
        })
      ),
    { dispatch: false }
  );

  constructor(private ErrorHandlerActions$: Actions) {}
}
